import { Student, StudentActivity } from './types';

// Generate a list of mock student activities
export const mockStudentActivities: StudentActivity[] = [
  // Student 001 Activities
  {
    id: 'activity-001',
    studentId: 'student-001',
    type: 'learning',
    timestamp: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString(),
    description: 'Completed "Addition and Subtraction" lesson',
    relatedId: 'standard-004',
    details: {
      standardId: 'standard-004',
      accuracy: 85,
      timeSpent: 1200,
      completionStatus: 'completed'
    }
  },
  {
    id: 'activity-002',
    studentId: 'student-001',
    type: 'game',
    timestamp: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString(),
    description: 'Played "Math Blaster" game',
    relatedId: 'game-001',
    details: {
      standardId: 'standard-004',
      score: 850,
      accuracy: 78,
      timeSpent: 600,
      completionStatus: 'completed'
    }
  },
  {
    id: 'activity-003',
    studentId: 'student-001',
    type: 'achievement',
    timestamp: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString(),
    description: 'Earned "Math Whiz" achievement',
    relatedId: 'achievement-001'
  },
  {
    id: 'activity-004',
    studentId: 'student-001',
    type: 'learning',
    timestamp: new Date(new Date().setHours(new Date().getHours() - 3)).toISOString(),
    description: 'Started "Place Value" lesson',
    relatedId: 'standard-007',
    details: {
      standardId: 'standard-007',
      accuracy: 60,
      timeSpent: 800,
      completionStatus: 'in-progress'
    }
  },
  {
    id: 'activity-005',
    studentId: 'student-001',
    type: 'game',
    timestamp: new Date(new Date().setHours(new Date().getHours() - 2)).toISOString(),
    description: 'Played "Number Cruncher" game',
    relatedId: 'game-002',
    details: {
      standardId: 'standard-007',
      score: 620,
      accuracy: 65,
      timeSpent: 450,
      completionStatus: 'completed'
    }
  },
  
  // Student 002 Activities
  {
    id: 'activity-006',
    studentId: 'student-002',
    type: 'learning',
    timestamp: new Date(new Date().setDate(new Date().getDate() - 2)).toISOString(),
    description: 'Completed "Number Sense" lesson',
    relatedId: 'standard-001',
    details: {
      standardId: 'standard-001',
      accuracy: 92,
      timeSpent: 1500,
      completionStatus: 'completed'
    }
  },
  {
    id: 'activity-007',
    studentId: 'student-002',
    type: 'game',
    timestamp: new Date(new Date().setDate(new Date().getDate() - 2)).toISOString(),
    description: 'Played "Fraction Action" game',
    relatedId: 'game-003',
    details: {
      standardId: 'standard-018',
      score: 720,
      accuracy: 80,
      timeSpent: 550,
      completionStatus: 'completed'
    }
  },
  
  // Student 003 Activities
  {
    id: 'activity-008',
    studentId: 'student-003',
    type: 'learning',
    timestamp: new Date(new Date().setDate(new Date().getDate() - 3)).toISOString(),
    description: 'Started "Multiplication" lesson',
    relatedId: 'standard-008',
    details: {
      standardId: 'standard-008',
      accuracy: 75,
      timeSpent: 900,
      completionStatus: 'in-progress'
    }
  },
  {
    id: 'activity-009',
    studentId: 'student-003',
    type: 'achievement',
    timestamp: new Date(new Date().setDate(new Date().getDate() - 3)).toISOString(),
    description: 'Earned "Quick Learner" achievement',
    relatedId: 'achievement-002'
  },
  
  // Student 004 Activities
  {
    id: 'activity-010',
    studentId: 'student-004',
    type: 'learning',
    timestamp: new Date(new Date().setDate(new Date().getDate() - 4)).toISOString(),
    description: 'Completed "Comprehensive Math Review" first lesson',
    relatedId: 'standard-004',
    details: {
      standardId: 'standard-004',
      accuracy: 88,
      timeSpent: 1100,
      completionStatus: 'completed'
    }
  },
  
  // More activities for Student 001 (most recent)
  {
    id: 'activity-011',
    studentId: 'student-001',
    type: 'learning',
    timestamp: new Date().toISOString(),
    description: 'Continued "Place Value" lesson',
    relatedId: 'standard-007',
    details: {
      standardId: 'standard-007',
      accuracy: 70,
      timeSpent: 300,
      completionStatus: 'in-progress'
    }
  },
  {
    id: 'activity-012',
    studentId: 'student-001',
    type: 'game',
    timestamp: new Date().toISOString(),
    description: 'Played "Math Challenge" game',
    relatedId: 'game-004',
    details: {
      standardId: 'standard-007',
      score: 750,
      accuracy: 82,
      timeSpent: 480,
      completionStatus: 'completed'
    }
  }
];

// Helper function to get activities for a specific student
export const getStudentActivities = (studentId: string): StudentActivity[] => {
  return mockStudentActivities.filter(activity => activity.studentId === studentId);
};

// Helper function to get recent activities for a specific student
export const getRecentStudentActivities = (studentId: string, limit: number = 5): StudentActivity[] => {
  return mockStudentActivities
    .filter(activity => activity.studentId === studentId)
    .sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime())
    .slice(0, limit);
};
